import { Colors } from '@revenuemarket/cds';

const NewBadge = () => {
  return (
    <div
      style={{
        borderRadius: 6,
        background: 'rgba(27, 141, 251, 0.12)',
        display: 'flex',
        height: '20px',
        padding: '8px 6px',
        justifyContent: 'center',
        alignItems: 'center',
        color: Colors.blue900,
        fontSize: 13,
      }}
    >
      NEW
    </div>
  );
};

export default NewBadge;
